import styled from 'styled-components'
import { Image as BoltImage } from '@sainsburys-tech/bolt'

const Image = styled(BoltImage)`
  height: ${props => (props.Incentivized ? 40 : 24)}px;
  margin: 10px 0px;
`

const TextBox = styled.div`
  max-width: 290px;
  border-radius: 3px;
  border: solid 1px ${props => props.theme.color.monochrome.light};
  font-size: ${props => props.theme.font.size.caption};
  line-height: normal;
  color: ${props => props.theme.color.monochrome.darker};
  padding: 7px 10px 7px 10px;
  margin: 7px 10px 7px 10px;
`

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const Badge = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 50px;
  margin-right: 10px;
  user-select: none;
`

const FlexRow = styled.div`
  display: flex;
`

export { Image, TextBox, Container, Badge, FlexRow }
